export { default as ColorPreviews } from './color-previews'
